
import React, { useState } from 'react';
import classnames from 'classnames';

const TabSwitch = ({ title, isActive, handleOnClick, idx }) => {
    const cx = classnames({
      'nav-link': true,
      active: isActive,
    })
    return (
      <li className="nav-item" onClick={() => handleOnClick(idx)}>
        <a className={cx} role="tab">
          {title}
        </a>
        <div className="slide" />
      </li>
    )
}
export default TabSwitch